import { useEffect, useState } from 'react';
import useCompareMediaQuery from '../../common/compare/useCompareMediaQuery';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';

const useCompareScrolling = () => {
  const [scrolling, setScrolling] = useState(false);
  const isAtLeastLarge = useLargeBreakpoint();
  const compareMediaQuery = useCompareMediaQuery();
  const [mediaQuery, setMediaQuery] = useState(compareMediaQuery);

  useEffect(() => {
    const handleScroll = () => {
      const tableEl = document.querySelector('.compare-table');
      const scrolledHeaderEl = document.querySelector(
        '.compare-header--scrolled-state'
      );
      const modalHeaderEl = document.querySelector('.modal-header--sticky');
      const tableElDimensions = tableEl.getBoundingClientRect();
      const tableElFromTop = tableElDimensions.top;
      const scrolledHeaderElHeight = scrolledHeaderEl.getBoundingClientRect()
        .height;
      const modalHeaderElHeight = modalHeaderEl.getBoundingClientRect().height;

      if (
        !scrolling &&
        tableElFromTop < scrolledHeaderElHeight + modalHeaderElHeight
      ) {
        scrolledHeaderEl.style.top = `${modalHeaderElHeight}px`;
        setScrolling(true);
      }
      if (
        scrolling &&
        tableElFromTop > scrolledHeaderElHeight + modalHeaderElHeight
      ) {
        scrolledHeaderEl.style.top = null;
        setScrolling(false);
      }
    };

    if (mediaQuery !== compareMediaQuery) {
      if (scrolling) {
        const scrolledHeaderEl = document.querySelector(
          '.compare-header--scrolled-state'
        );
        const modalHeaderEl = document.querySelector('.modal-header--sticky');
        const modalHeaderElHeight = modalHeaderEl.getBoundingClientRect()
          .height;
        scrolledHeaderEl.style.top = `${modalHeaderElHeight}px`;
        setMediaQuery(compareMediaQuery);
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolling, isAtLeastLarge, mediaQuery, compareMediaQuery]);

  return [scrolling, setScrolling];
};

export const useCompareIsScrolledUp = () => {
  const [isScrolledUp, setIsScrolledUp] = useState(false);

  useEffect(() => {
    let previousYOffset = window.scrollY;

    const updateScrolledUp = () => {
      const currentYOffset = window.scrollY;
      setIsScrolledUp(currentYOffset < previousYOffset ? true : false);
      previousYOffset = currentYOffset;
    };
    window.addEventListener('scroll', updateScrolledUp);
    return () => {
      window.removeEventListener('scroll', updateScrolledUp);
    };
  }, [isScrolledUp]);

  return [isScrolledUp, setIsScrolledUp];
};

export const compareScrollToRef = (ref) => {
  const modalHeaderEl = document.querySelector('.modal-header');
  const modalHeaderElBottom = modalHeaderEl.getBoundingClientRect().bottom;
  const compareHeaderEl = document.querySelector(
    '.compare-header--scrolled-state'
  );
  const compareHeaderElHeight = compareHeaderEl.getBoundingClientRect().height;
  const refTop = ref.current.getBoundingClientRect().top;

  const offset = Math.trunc(
    refTop - modalHeaderElBottom - compareHeaderElHeight
  );
  window.scrollBy(0, offset);
};

export default useCompareScrolling;
